import React, { useEffect } from 'react';
import './newhere.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake, faTshirt, faChild } from '@fortawesome/free-solid-svg-icons';
import newhereHeroBackground from '../../assets/new-here/background.png';

const NewHere = () => {
  useEffect(() => {
    const img = new Image();
    img.src = newhereHeroBackground;
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /* Fallback: ensure first content is visible even if CSS animation doesn't run */
  useEffect(() => {
    const t = setTimeout(() => {
      const el = document.querySelector('.newhere-first-content');
      if (el) el.classList.add('first-content-visible');
    }, 1500);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.15
    };

    const handleIntersect = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);

    document.querySelectorAll('.fade-in-section').forEach(section => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section className="background-section">
        <h1 className="background-title">YOUR JOURNEY BEGINS HERE</h1>
      </section>

      <section className="welcome-section newhere-first-content">
        <h2 className="welcome-title">You Are Welcome Here!</h2>
        <div className="divider"></div>
        <p className="welcome-description">
          We warmly embrace everyone who walks through our doors, extending a sincere invitation to experience a sense of belonging and acceptance in our church family. You're welcome here, just as you are.
        </p>
        <button
          className="plan-visit-button"
          onClick={() => window.location.href = '/visit-us'}
        >
          Plan Your Visit
        </button>
      </section>

      <section className="info-section fade-in-section" aria-labelledby="what-to-expect-title">
        <h2 id="what-to-expect-title" className="section-title">What to Expect?</h2>
        <div className="divider"></div>
        <div className="expect-container">
          <div className="expect-card fade-in-section">
            <FontAwesomeIcon icon={faHandshake} className="icon animated-icon" />
            <h3>What are Sunday Services Like?</h3>
            <p>
              Our Sunday services are a vibrant and uplifting experience, filled with inspiring worship, heartfelt sermons, and a strong sense of community. You can expect engaging music, relevant teachings, and a warm atmosphere where people of all ages can connect and grow in their faith.
            </p>
          </div>
          <div className="expect-card fade-in-section">
            <FontAwesomeIcon icon={faTshirt} className="icon animated-icon" />
            <h3>What Should I Wear?</h3>
            <p>
              When attending our church services, we encourage you to dress comfortably and respectfully, keeping in mind the sanctity of the place and the reverence for the worship experience.
            </p>
          </div>
          <div className="expect-card fade-in-section">
            <FontAwesomeIcon icon={faChild} className="icon animated-icon" />
            <h3>What About My Kids?</h3>
            <p>
              We value the presence of children in our church services and believe they should have the opportunity to worship alongside their parents. We encourage families to worship together, strengthening family bonds and fostering growth.
            </p>
          </div>
          <div className="expect-card fade-in-section">
            <FontAwesomeIcon icon={faHandshake} className="icon animated-icon" />
            <h3>What is My Next Step?</h3>
            <p>
              Embark on your spiritual journey within our intimate church family. Take part in our collective worship, engage with fellow congregants, and connect with us directly to explore ways to deepen your involvement in our church.
            </p>
          </div>
        </div>
      </section>

      <section className="service-section fade-in-section" aria-labelledby="sunday-services-title">
  <h2 id="sunday-services-title" className="section-title">Sunday Services</h2>
  <div className="divider"></div>
  <div className="service-details">
    <div className="service-card fade-in-section">
      <h3>Sunday School</h3>
      <p>9:00 AM</p>
      <p>Interactive and age-appropriate Bible lessons for all children and youth.</p>
    </div>
    <div className="service-card fade-in-section">
      <h3>Sunday Service</h3>
      <p>9:45 AM</p>
      <p>Experience worship and teaching in Malayalam & English with translation, perfect for all ages.</p>
    </div>
  </div>
</section>

      <section className="join-section fade-in-section" aria-labelledby="join-us-title">
        <h2 id="join-us-title" className="section-title">Join Us!</h2>
        <div className="divider"></div>
        <p>Let us know you're coming! We would love to meet you</p>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSfQqpsfZ-hQKKeykQ7-2JD2pyGYApycuW9oLsUi_39LlDajfA/viewform?usp=dialog"
          target="_blank"
          rel="noopener noreferrer"
          className="plan-visit-button"
          style={{ textDecoration: 'none' }}
        >
          Visitor Forum
        </a>
      </section>
    </>
  );
};

export default NewHere;
